import * as React from "react";
import { QueryStateBoundary } from "@/components/dashboard/QueryStateBoundary";
import { TradeSummaryCard } from "../TradeSummaryCard";
import { useTradeBook } from "@/hooks/queries/useTradeBook";
import type { TradeRow } from "../TradeTable";

interface ExecutionOrderPayload {
  execution_id: string;
  instrument_token: string;
  side: string;
  quantity: number;
  status: string;
}

export function TradeSummarySection(): React.JSX.Element {
  const tradeBookQuery = useTradeBook();

  return (
    <QueryStateBoundary query={tradeBookQuery}>
      {(payload) => {
        const rows: TradeRow[] = (payload as unknown as ExecutionOrderPayload[]).map((t) => ({
          execution_id: t.execution_id,
          instrument_token: t.instrument_token,
          side: t.side,
          quantity: t.quantity,
          status: t.status,
        }));
        return <TradeSummaryCard trades={rows} />;
      }}
    </QueryStateBoundary>
  );
}
